import React, { useState, useEffect, useRef } from "react";
import axiosInstance from './../axiosInstance.js';



// We deal with tags as strings only.
// TODO: remove initFocus
// TODO (!!!): deal with tags as objects, not strings. It will allow to add more info to tags, like color, type, etc.
const TagsInput = ({ 
  initialTags = [], // required
  selectedTag, 
  onTagsChange, 
  editable = true,
  language, // required 
  onSelectionChange,
  reducedView = false, // For reduced view (only global manual tags shown)
  initialTagObjects = [],
 }) => {
  const [isSelectable, setIsSelectable] = useState(selectedTag && selectedTag !== "");
  const [tags, setTags] = useState(initialTags); // Initialize with array of strings
  const [searchResults, setSearchResults] = useState([]); // For auto-complete
  const [searchQuery, setSearchQuery] = useState(""); // Input field query
  const [isDropdownVisible, setIsDropdownVisible] = useState(false); // Manage dropdown visibility (for search)
  const [selectedGlobalManualTag, setSelectedGlobalManualTag] = useState(initialTags.find(isGlobalManualTag)); // State for selected global manual tag
  const [isInputVisible, setIsInputVisible] = useState(false); // State to toggle input visibility
  const [isGlobalManualTagDropdownVisible, setIsGlobalManualTagDropdownVisible] = useState(false); // State to toggle global manual tag dropdown

  // TODO: make it part of is global automatic tag
  const genreTagsNames = initialTagObjects.filter(tag => tag.type === 5).map(tag => tag.name);

  const inputRef = useRef(null); // Ref for the input element
  const dropdownRef = useRef(null); // Ref for the search dropdown menu
  const globalManualTagDropdownRef = useRef(null); // Ref for the global manual tag dropdown

  // const [initFocusRelevant, setInitFocusRelevant] = useState(true);
  // useEffect(() => {
  //   if (inputRef.current && initFocus && initFocusRelevant) {
  //     inputRef.current.focus();
  //     setInitFocusRelevant(false); // is it really needed here?
  //   }
  // });

  const addTag = (tag) => {
    let updatedTags = [...tags];

    if (isGlobalManualTag(tag)) {
      // Remove previous global manual tag.
      updatedTags = updatedTags.filter(tagName => !isGlobalManualTag(tagName));
    }

    if (updatedTags.length === 8){
      let txt = "Maximum 8 tags";
      if (language === "ru") {
        txt = "Максимум 8 тэгов";
      }
      alert(txt);
      return;
    }

    if (!updatedTags.includes(tag)) { // Check if tag is already included
      updatedTags = [...updatedTags, tag];
      setTags(updatedTags);
      onTagsChange(updatedTags); // Notify the parent of updated tags
    }
  };

  const removeTag = (tag) => {
    const updatedTags = tags.filter((t) => t !== tag);
    setTags(updatedTags);
    onTagsChange(updatedTags); // Notify the parent of updated tags
  };

  const handleSearch = async (query) => {
    setSearchQuery(query);
    if (query.length > 0 || true) {
      try {
        const response = await axiosInstance.get(`/relevant/tags/search?query=${query}`);
        setSearchResults(response.data.map(item => item.name));
        setIsDropdownVisible(true); // Show the dropdown when there are results
      } catch (error) {
        console.error("Error fetching search results:", error);
      }
    } else {
      setSearchResults([]); // Clear search results if input is empty
      setIsDropdownVisible(false); // Hide the dropdown if there are no results
    }
  };

  const handleAddTag = (tag) => {
    addTag(tag);
    setSearchQuery(""); // Clear the search input after adding
    setSearchResults([]); // Clear the search results after adding
    setIsDropdownVisible(false); // Hide the dropdown after adding
  };

  const handleInputChange = (e) => {    
    handleSearch(e.target.value);
  };

  const handleDropdownItemClick = (tag) => {
    handleAddTag(tag);
    setIsDropdownVisible(false);
    // setInitFocusRelevant(false);
  };

  const handleGlobalManualTagSelection = (tag) => {
    setSelectedGlobalManualTag(tag);
    addTag(tag); // Add the selected global manual tag
  };

  const handleClickOutside = (event) => {
    // Hide the search dropdown if clicking outside
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) 
      // inputRef.current &&
      // !inputRef.current.contains(event.target)
    ) {
      setIsDropdownVisible(false);
    }

    // Hide the global manual tag dropdown if clicking outside
    if (
      globalManualTagDropdownRef.current &&
      !globalManualTagDropdownRef.current.contains(event.target)
    ) {
      setIsGlobalManualTagDropdownVisible(false);
    }
  };

  useEffect(() => {
    // Add event listener for clicks outside the component
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  return (
    <div className="relative px-2 md:px-4">
      {/* Display global manual tags and added tags */}
      <div className="flex justify-center flex-wrap items-center gap-1">
        {editable ? (
          initialTags.length > 0 && selectedGlobalManualTag ? (
            <div className="relative" ref={globalManualTagDropdownRef}>
              <div
                className={
                  "px-2 py-1 rounded text-base md:text-lg cursor-pointer " +
                  tagColor(selectedGlobalManualTag)
                }
                onClick={() => setIsGlobalManualTagDropdownVisible(!isGlobalManualTagDropdownVisible)} // Toggle dropdown visibility
              >
                <span className="flex text-center items-center">
                  {tagName(selectedGlobalManualTag, language) + " ▼"}
                </span>
              </div>
              {isGlobalManualTagDropdownVisible && (
                <div className="absolute top-full left-0 mt-1 bg-white border border-gray-300 rounded shadow-md z-50">
                  {["like", "veryGood", "good", "finished", "bad", "todo"]
                    .filter((tag) => tag !== selectedGlobalManualTag) // Exclude the currently selected tag
                    .map((tag, index) => (
                      <div
                        key={index}
                        className={
                          "px-2 py-1 cursor-pointer hover:bg-gray-200 " + tagColor(tag, false)
                        }
                        onClick={() => {
                          setSelectedGlobalManualTag(tag); // Update selected tag
                          addTag(tag); // Add the selected tag
                          setIsGlobalManualTagDropdownVisible(false); // Hide dropdown
                        }}
                      >
                        {tagName(tag, language)}
                      </div>
                    ))}
                </div>
              )}
            </div>
          ) : (
            ["like", "veryGood", "good", "finished", "bad", "todo"].map((tag, index) => (
              <div
                key={index}
                className={
                  "px-2 py-1 rounded text-base md:text-lg cursor-pointer " +
                  (selectedGlobalManualTag === tag
                    ? tagColor(tag)
                    : "bg-gray-300 text-gray-600")
                }
                onClick={() => {
                  setSelectedGlobalManualTag(tag);
                  addTag(tag); // Add the selected tag
                }}
              >
                {tagName(tag, language)}
              </div>
            ))
          )
        ) : (
          selectedGlobalManualTag && (
            <div
              className={
                "px-1 rounded text-base md:text-lg " + tagColor(selectedGlobalManualTag)
              }
            >
              {tagName(selectedGlobalManualTag, language)}
            </div>
          )
        )}

        {!reducedView &&
        <>
          {/* Display added tags */}
          {tags.filter(tag => !isGlobalManualTag(tag) && !isGlobalAutomaticTag(tag) && !genreTagsNames.includes(tag)).map((tag, index) => (
            <div
              key={index}
              className={"px-2 py-1 rounded text-base md:text-lg " + // Increased padding and font size
                tagColor(tag) + 
                (tag === selectedTag ? " border-2 border-blue-500 border-dashed" : "") + 
                (isSelectable ? " cursor-pointer" : "")}
              onClick={() => {
                  onSelectionChange(tag);
              }}
            >
              {
              tag.includes("\\")
              ?
                <div className="flex items-center text-center">
                  #
                  <img className="w-5 max-w-none h-5 rounded-full" src={tag.split("\\")[1]} />
                  {tagName(tag.split("\\")[0], language)}                
                </div>
              :
                <>
                  {tagName(tag, language)}
                </>
              }

              {
              (!isGlobalAutomaticTag(tag) && editable) &&
              <button
                className="ml-2 text-xs lg:text-sm text-gray-500 text-white"
                onClick={() => removeTag(tag)}
              >
                &times;
              </button>
              }
            </div>
          ))}

          {/* Add "+" button */}
          {(editable && selectedGlobalManualTag) && (
            <button
              className={
                "px-4 py-1 rounded-3xl text-base md:text-lg cursor-pointer " +
                "bg-[#6b7280] text-white" // Same color as added tags
              }
              onClick={() => setIsInputVisible(!isInputVisible)} // Toggle input visibility
            >
              +
            </button>
          )}
        </>
        }
      </div>

      {/* Input field */}
      {isInputVisible && editable && (
        <div className="mt-1 w-full flex justify-center"> {/* Input on a new line */}
          <input
            ref={inputRef}
            type="text"
            inputmode="search"
            className="border border-gray-300 rounded p-1 leading-none text-base md:text-lg w-auto text-center"
            placeholder={language === "ru" ? "Введите название тэга" : "Enter tag name"}
            value={searchQuery}
            onChange={handleInputChange}
            onFocus={handleInputChange}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && searchQuery.trim() !== '') {
                handleAddTag(searchQuery.trim()); // Add tag on Enter key press
                setIsInputVisible(false); // Hide input after adding
              }
            }}
            onBlur={() => setIsInputVisible(false)} // Hide input on blur
          />
        </div>
      )}

      {/* Search Results Dropdown */}
      {isDropdownVisible && searchResults.length > 0 && (
        <div
          ref={dropdownRef}
          className="absolute top-full left-0 right-0 border border-gray-300 rounded mb-2 max-h-40 overflow-y-auto z-[60]"
        >
          {searchResults.map((tag, index) => (
            <div
              key={index}
              className={"p-2 cursor-pointer " + tagColor(tag, false)}
              onMouseDown={() => handleDropdownItemClick(tag)} /* for some f*** unknown reason onclick doesn't work! */
            >
              {tagName(tag, language)}
            </div>
          ))}
        </div>
      )}
      
    </div>
  );
};

// Define isGlobalManualTag before useState
const isGlobalManualTag = (name) => {
  return ["like", "todo", "finished", "veryGood", "good", "bad"].includes(name);
};

// It should be handled in backend.
const isGlobalAutomaticTag = (name) => {
  if (name === "book" || name === "movie" || name === "game" || name === "youtubechannel") {
    return true;
  }
  return false;
}

export const tagColor = (name, rounded = true, bgColorOverride, type = 0) => {
  const base = `font-sans font-medium tracking-wide text-[11px] px-2.5 py-0.5 
               ${rounded ? "rounded-full" : ""}`;

  if (bgColorOverride) {
    return `${base} ${bgColorOverride} text-white`;
  }

  if (isGlobalManualTag(name)) {
    switch (name) {
      case "like":        // ❤️ Любимое
        return `${base} bg-red-500/90 text-white shadow-sm`;
      case "veryGood":    // ⭐ Очень понравилось
        return `${base} bg-orange-500/90 text-white shadow-sm`;
      case "good":        // ⭐ Понравилось
        return `${base} bg-green-500/90 text-white shadow-sm`;
      case "todo":        // 📌 В планах
        return `${base} bg-sky-300/90 text-white shadow-sm`;
      case "finished":    // ⚪ Нейтрально
        return `${base} bg-yellow-500/90 text-white shadow-sm`;
      case "bad":         // 👎 Не понравилось
        return `${base} bg-gray-600/90 text-white shadow-sm`;
    }
  }

  // automatic tag (unchanged)
  if (isGlobalAutomaticTag(name)) {
    return `${base} bg-teal-500/80 text-white`;
  }

  // fallback (unchanged)
  if (type === 5) {
    return `${base} bg-[#4f465d] text-white`;
  }

  return `${base} bg-gray-500 text-white`;
};

export const tagName = (name, language) => {
  const mapping = {
    en: {
      like:      "❤️ favorite",
      veryGood:  "⭐ very good",
      good:      "⭐ good",
      todo:      "📌 todo",
      finished:  "⚪ neutral",
      bad:       "👎 bad",

      book: "📖",
      movie: "🎥",
      game: "🎮",
      youtubechannel: "youtube"
    },

    ru: {
      like:      "❤️ любимое",
      veryGood:  "⭐ очень понравилось",
      good:      "⭐ понравилось",
      todo:      "📌 планы",
      finished:  "⚪ нейтрально",
      bad:       "👎 не понравилось",

      book: "📖",
      movie: "🎥",
      game: "🎮",
      youtubechannel: "youtube"
    }
  };

  const val = mapping[language][name];
  return val === undefined ? "#"+name : val;
};

export default TagsInput;
